// @ts-ignore
import icon from "../../images/burger-menu-icon.png";

type Props = {
  onClick?: () => void;
};

// Render a burger menu toggle button
// @param {function} onClick
function BurgerMenuButton({ onClick }: Props) {
  // TODO: use classnames directly in elements
  const className = `
    w-5
    h-5
  `;
  return (
    <button id="burger_menu_button" onClick={onClick} className={className}>
      <img
        className="h-5 w-5 object-scale-down"
        alt="menu button icon"
        src={icon}
      />
    </button>
  );
}

export default BurgerMenuButton;
